import request from '@/utils/request'


// 报表查询
export function pageQuery(data) {
    return request({
        url: '/db/report-record/query',
        method: 'post',
        data
    })
}


// 报表查询
export function updateDownloadCount(data) {
    return request({
        url: '/db/report-record/update-Download-count',
        method: 'post',
        data
    })
}
